enum RouteEnum {
  Welcome = '/',
  Auth0CallbackPage = '/callback',
  Environments = '/environments',
  Builds = '/builds',
}

export default RouteEnum;
